import Router from "./Router";
import { createContext, React, useContext, useReducer, useState } from "react";
import { theme, App } from "antd";
import {
  ApolloClient,
  ApolloProvider,
  InMemoryCache,
  split,
  HttpLink,
} from "@apollo/client";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";

import GlobalContext from "./Component/GlobalContext";

const ThemeContext = createContext(null);

const createApolloClient = (authToken) => {
  const httpLink = new HttpLink({
    uri: "https://selected-pipefish-60.hasura.app/v1/graphql",
    headers: {
      "x-hasura-admin-secret": authToken,
    },
  });

  const wsLink = new WebSocketLink({
    uri: "wss://selected-pipefish-60.hasura.app/v1/graphql",
    options: {
      lazy: true,
      reconnect: true,
      timeout: 5000,
      connectionParams: {
        headers: {
          "x-hasura-admin-secret": authToken,
        },
      },
    },
  });

  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === "OperationDefinition" &&
        definition.operation === "subscription"
      );
    },
    wsLink,
    httpLink
  );

  return new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "cache-and-network",
      },
      query: {
        fetchPolicy: "network-only",
      },
    },
  });
};

const initialTheme = {
  theme: theme.defaultAlgorithm,
  name: "light",
};

const reducer = (state, action) => {
  switch (action.type) {
    case "lightMode":
      return { theme: theme.defaultAlgorithm, name: "light" };
    case "darkMode":
      return { theme: theme.darkAlgorithm, name: "dark" };
    default:
      throw new Error();
  }
};

const ThemeSwitchProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialTheme);
  return (
    <ThemeContext.Provider value={{ state, dispatch }}>
      {props.children}
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => {
  return useContext(ThemeContext);
};

export default function MyApp() {
  const [client] = useState(
    createApolloClient(process.env.REACT_APP_HASURA_ADMIN_SECRET)
  );
  return (
    <ApolloProvider client={client}>
      <App>
        <ThemeSwitchProvider>
          <GlobalContext>
            <Router />
          </GlobalContext>
        </ThemeSwitchProvider>
      </App>
    </ApolloProvider>
  );
}
